import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let CharacterSheetTicker = class CharacterSheetTicker extends Vue {
};
__decorate([
    Prop(Number)
], CharacterSheetTicker.prototype, "current", void 0);
__decorate([
    Prop(Number)
], CharacterSheetTicker.prototype, "max", void 0);
CharacterSheetTicker = __decorate([
    Component
], CharacterSheetTicker);
export default CharacterSheetTicker;
